// angular
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
import { AppService } from '../../app.service';
import { MeDiagnosisPredictionService } from '../dashboard/cards/diagnosis-prediction/diagnosis-prediction.service';

@Component({
    selector: 'me-diagnosis-prediction',
    templateUrl: './diagnosis-prediction.component.html',
    styleUrls: ['./diagnosis-prediction.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MeDiagnosisPredictionService]
})

export class MeDiagnosisPredictionComponent implements OnInit {
    data: any;
    url = 'diagnosis-prediction/';
    articleType = '';
    packageData;

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public diagnosisService : MeDiagnosisPredictionService,
        public router: Router
    ) {
       
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            let name = params.get('name');
            this.url = 'diagnosis-prediction/' + name;
            this.getContent();
        });

        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            if (this.data.upsell_offer) {
                this.articleType = this.data.upsell_offer.cached_url.split("/").pop();
                this.getPredictionPackageCard(this.articleType);
            }
            this.appService.isLoading = false;
        }, error => {
            window.alert('Content not found');
            this.appService.isLoading = false;
            this.router.navigate(['me']);
        });
    }

    toTop() {
        (document.getElementById('diagnosis-prediction-page') as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

    back() {
        history.back();
    }

    getPredictionPackageCard(articleType) {
        this.diagnosisService.getDiagnosisPredictionPackage(articleType).subscribe(res => {
            this.packageData = res['package'];
        });
    }
}
